import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {GalleryModule} from '@ngx-gallery/core';
import {LightboxModule} from '@ngx-gallery/lightbox';
import {RecaptchaFormsModule, RecaptchaModule, RECAPTCHA_LANGUAGE} from 'ng-recaptcha';
import {NgxPageScrollModule} from 'ngx-page-scroll';
import {NgxPageScrollCoreModule} from 'ngx-page-scroll-core';
import {SharedModule} from '../shared/shared.module';
import {ProductAdapter} from './adapter/product.adapter';
import {CatalogueRoutingModule} from './catalogue-routing.module';
import {ContainerComponent} from './components/container/container.component';
import {ProductComponent} from './components/product/product.component';
import {SearchResolver} from './components/search/search-resolver';
import {SearchComponent} from './components/search/search.component';
import {ProductResolver} from './services/product.resolver';
import {ClampyModule} from '@clampy-js/ngx-clampy';
import {ConvertQueryParamsService} from './services/convert-query-params.service';
import {ArticleAdapter} from "./adapter/article.adapter";
import {ArticleResolver} from "./services/article.resolver";
import {ArticleComponent} from "./components/article/article.component";
import {ArticleAttributesComponent} from "./components/article/article-attributes/article-attributes.component";
import {ViewModule} from "../view/view.module";
import {ArticleImageComponent} from "../shared/components/article-image/article-image.component";
import {
    ArticleUpdateQuantityComponent
} from "../shared/components/article-update-quantity/article-update-quantity.component";
import {
    ArticlePricePerPriceUnitWrapperComponent
} from "../shared/components/article-price-per-price-unit-wrapper/article-price-per-price-unit-wrapper.component";
import {VideoModalComponent} from "../shared/components/video-modal/video-modal.component";
import {LoginModalComponent} from "./components/login-modal/login-modal.component";
import {AppSearchComponent} from "./components/app-search/app-search.component";
import {AppSearchResolver} from "./services/app-search.resolver";
import {AppSearchAdapter} from "./adapter/app-search.adapter";
import {AppSearchResultsComponent} from "./components/app-search/app-search-results/app-search-results.component";
import {AppSearchFacetsComponent} from "./components/app-search/app-search-facets/app-search-facets.component";
import {
    AppSearchPaginationComponent
} from "./components/app-search/app-search-pagination/app-search-pagination.component";
import {AppSearchFacetComponent} from "./components/app-search/app-search-facet/app-search-facet.component";
import {
    AppSearchBreadcrumbsComponent
} from "./components/app-search/app-search-breadcrumbs/app-search-breadcrumbs.component";
import {
    AppSearchHierarchyFacetsComponent
} from "./components/app-search/app-search-hierarchy-facets/app-search-hierarchy-facets.component";
import {
    AppSearchToggleFacetsBarComponent
} from "./components/app-search/app-search-toggle-facets-bar/app-search-toggle-facets-bar.component";
import {
    AppSearchHierarchyFacetOptionComponent
} from "./components/app-search/app-search-hierarchy-facet-option/app-search-hierarchy-facet-option.component";
import { SwiperModule } from 'ngx-swiper-wrapper';

@NgModule({
    declarations: [
        ContainerComponent,
        SearchComponent,
        ProductComponent,
        ArticleComponent,
        ArticleAttributesComponent,
        LoginModalComponent,
        AppSearchComponent,
        AppSearchResultsComponent,
        AppSearchFacetsComponent,
        AppSearchFacetComponent,
        AppSearchPaginationComponent,
        AppSearchBreadcrumbsComponent,
        AppSearchHierarchyFacetsComponent,
        AppSearchHierarchyFacetOptionComponent,
        AppSearchToggleFacetsBarComponent,
    ],
    imports: [
        CommonModule,
        CatalogueRoutingModule,
        FormsModule,
        NgbModule,
        SharedModule,
        GalleryModule,
        NgxPageScrollModule,
        SwiperModule,
        LightboxModule.withConfig({
            panelClass: 'fullscreen'
        }),
        RecaptchaModule,
        RecaptchaFormsModule,
        NgxPageScrollCoreModule.forRoot({
            duration: 250,
            scrollOffset: 80, // Compensate for the header.
        }),
        ClampyModule,
        ViewModule,
    ],
    providers: [
        SearchResolver,
        ProductAdapter,
        ArticleAdapter,
        ProductResolver,
        ArticleResolver,
        AppSearchResolver,
        ConvertQueryParamsService,
        AppSearchAdapter,
        {
            provide: RECAPTCHA_LANGUAGE,
            useValue: localStorage.getItem('locale') ? localStorage.getItem('locale') : window['__env'].defaultLocale
        }
    ],
    entryComponents: [
        ArticleImageComponent,
        ArticleUpdateQuantityComponent,
        ArticlePricePerPriceUnitWrapperComponent,
        VideoModalComponent,
        LoginModalComponent,
    ]
})
export class CatalogueModule {
}
